import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
const NotifyModal = () => {
  const { user, token } = useSelector((state) => state.auth);
  const [email, setEmail] = useState(user?.email || "");
  const [currentProductId, setCurrentProductId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [emailError, setEmailError] = useState("");
  // Listen for modal open events
  // console.log("currentProductId", currentProductId)
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    
    // Validate email
    if (!value) {
      setEmailError("Email is required");
    } else if (!emailPattern.test(value)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate email before submitting
    if (!email) {
      setEmailError("Email is required");
      return;
    }
    if (!emailPattern.test(email)) {
      setEmailError("Please enter a valid email address");
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/notify/subscribe`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("token")}`
        },
        body: JSON.stringify({
          email: email,
          product_id: currentProductId,
        }),
      });
      // console.log(response)
      const data = await response.json();
      if (data.success) {
        toast.success(data.message);
        document
          .getElementById("notify-modal")
          .querySelector('[data-bs-dismiss="modal"]')
          .click();
        const otpModalEl = document.querySelector("#notify-success");
        const otpModal = new window.bootstrap.Modal(otpModalEl);
        otpModal.show();
        setEmail("");
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to set notification"
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const modal = document.getElementById("notify-modal");
    modal.addEventListener("show.bs.modal", (event) => {
      const button = event.relatedTarget;
      const productId = button.getAttribute("data-product-id");
      setCurrentProductId(productId);
    });
  }, []);

  // Update email when user changes
  useEffect(() => {
    if (user?.email) {
      setEmail(user.email);
    }
  }, [user]);

  return (
    <>
      <div
        className="modal fade cancel-modal"
        id="notify-modal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Notify
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="fa fa-times" />
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="custom-frm-bx">
                  <label>Email Address</label>
                  <input
                    type="email"
                    className={`form-control ${emailError ? 'is-invalid' : ''}`}
                    id="notify-email"
                    value={email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                    required
                  />
                  {emailError && (
                    <div className="invalid-feedback">
                      {emailError}
                    </div>
                  )}
                </div>
                <div className="text-center">
                  <button
                    type="submit"
                    className="thm-btn w-100 bg-btn"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <span className="spinner-border spinner-border-sm me-2" />
                    ) : (
                      <i className="fas fa-bell me-2" />
                    )}
                    Notify Me
                  </button>
                  {/* <button type='button' className='thm-btn w-100' data-bs-toggle="modal" data-bs-target="#notify-success">Submit</button> */}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotifyModal;
